import * as React from 'react';
import { PCImage } from 'app/design/primitives/image';
import { images } from 'app/design/images';

export default function IntroRefrain2({ width = 317, height = 216 }: { width?: number; height?: number }) {
  return <PCImage height={height} source={images.introRefrain2} width={width} />;
}
